import axios, { CancelTokenSource } from "axios";
import { baseAxios } from "./Interceptor";
// import { baseAxios } from "./HttpClient";

export async function uploadFile(
    data: any,
    uploadUrl: string
  ): Promise<any> {
    let updateProgressBarValue: number = 0;
    let upload: CancelTokenSource | null = null;
    // console.log('url', uploadUrl)
    try {
      upload = baseAxios.CancelToken.source();
      const file = new File([data], 'modeldescription', { type: 'text/plain' });
      const config = {
        cancelToken: upload.token,
        headers: {
          'Content-Type': 'text/plain',
        },
      };
      // console.log('file', file)
      const res = await axios.put(uploadUrl, file, config);
        
      if (uploadUrl) {
        return res;
      }
      return res.data;
    } catch (err) {
      throw new Error();
    }
  }



  